// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-popover.help{max-width:min(75vw,380px);width:-moz-max-content;width:max-content;padding:2.4rem;border:1px solid #a8a8a8;line-height:1.8;font-size:1.3rem;color:#333}.el-popover.help b{color:#659fd1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
